var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"go-service udesk-go-service-main"},[_c('i',{staticClass:"iconfont-ot-website"},[_vm._v("")]),_c('span',{staticClass:"text"},[_vm._v("在线客服")])])
}]

export { render, staticRenderFns }